import { v4 as randomUUID } from 'uuid';
export function genUniqueId(usedIds: string[]): string {
    const id = new Date().getTime() + '';
    if (usedIds.indexOf(id) > -1) {
        return genUniqueId(usedIds);
    } else {
        return id;
    }
}

export const INTERVAL_REG_EXP = /^(0{0,1}[1-9]|1[0-2])\/[0-9]{4}$/;

function getCurrentOrLastYear(years: number[]): number {
    const currentYear = new Date().getFullYear();
    if (years.length === 0 || years.includes(currentYear)) {
        return currentYear;
    } else {
        return years[years.length - 1];
    }
}

export function parseInterval(start: string | null | undefined, end: string | null | undefined, years: number[]) {
    const fallbackYear = getCurrentOrLastYear(years);
    const startFixed =
        start !== null && start !== undefined && INTERVAL_REG_EXP.test(start) ? start : `01/${fallbackYear}`;
    const [startMonth, startYear] = startFixed.split('/').map((p) => Number.parseInt(p));
    const endFixed = end !== null && end !== undefined && INTERVAL_REG_EXP.test(end) ? end : `12/${fallbackYear}`;
    const [endMonth, endYear] = endFixed.split('/').map((p) => Number.parseInt(p));
    return { startMonth, startYear, endMonth, endYear };
}

export function downloadFile(blob: Blob, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);

    const file = window.URL.createObjectURL(blob);
    a.href = file;
    a.download = fileName;
    a.click();
    a.remove();
}

export function getSheetRowInfoFromPath(path: string): {
    sheetId: number | null;
    sheetRowId: number | null;
} {
    let sheetId: number | null = null;
    let sheetRowId: number | null = null;

    const pathArray: number[] = path.split('_').map((n) => Number.parseInt(n));

    // checking length cos first element of row path-string is always sheetId,
    // and selected sheetRowId is the last one (or isn't there at all if no row selected aka array length <= 1)
    if (pathArray.length) {
        sheetId = pathArray[0];
    }
    if (pathArray.length > 1) {
        const lastElement = pathArray.pop();
        if (lastElement) {
            sheetRowId = lastElement;
        }
    }
    return { sheetId, sheetRowId };
}

export function generateUniqueId<T extends { id: string }>(items: readonly Readonly<T>[]): string {
    let uniqueId: string;
    do {
        uniqueId = randomUUID();
    } while (items.some((item) => item.id === uniqueId));
    return uniqueId;
}
